import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { LoadingIndicatorDirective } from '@zero/shared/ui-directives';
import { ButtonComponent } from '@zero/shared/ui-web-design-system';
import { AuthPayloadSessionAuth, AuthorizationData } from '@zero/shared/util-models';
import { PreAuthorizationSessionAuth, SessionTanService } from '@zero/shared/util-web-app-services';
import {
  TransactionAuthorizationComponent,
  TransactionAuthorizationResult,
} from '../transaction-authorization/transaction-authorization.component';

@Component({
  selector: 'login-oauth-components-trading-session',
  templateUrl: './trading-session.component.html',
  imports: [LoadingIndicatorDirective, TransactionAuthorizationComponent, ButtonComponent],
})
export class TradingSessionComponent implements OnInit {
  @Input() public verifyIsSessionAuthorized = true;
  @Input() public dataToAuthorize: AuthorizationData<AuthPayloadSessionAuth> | AuthorizationData<PreAuthorizationSessionAuth>;

  @Output() public authorizationState = new EventEmitter<boolean>();

  public sessionAuthorized = false;
  public ongoingRequest = false;
  public errors: string[] = [];
  public userAbortedAuth: boolean;

  readonly #tanService = inject(SessionTanService);

  ngOnInit(): void {
    if (this.verifyIsSessionAuthorized) {
      this.ongoingRequest = true;
      this.#tanService.isSessionAuthorized().subscribe((result) => {
        if (result.success) {
          this.sessionAuthorized = result.data;
          if (!result.data) {
            this.dataToAuthorize = new AuthorizationData<AuthPayloadSessionAuth>(new AuthPayloadSessionAuth());
          }
        } else {
          this.errors.push(result.message);
          this.sessionAuthorized = false;
        }
        this.ongoingRequest = false;
        this.authorizationState.emit(this.sessionAuthorized);
      });
    }
  }

  public authorizedTransactionResult(result: TransactionAuthorizationResult): void {
    if (result.success) {
      this.sessionAuthorized = true;
      this.authorizationState.emit(true);
    } else {
      this.sessionAuthorized = false;
      if (result.reason === 'CanceledByUser') {
        this.authorizationState.emit(false);
        this.userAbortedAuth = true;
        this.dataToAuthorize = undefined;
      } else if (result.reason) {
        this.errors.push(result.reason);
      }
    }
  }

  public restartAuth(): void {
    this.userAbortedAuth = false;

    if (this.verifyIsSessionAuthorized) {
      this.dataToAuthorize = new AuthorizationData<AuthPayloadSessionAuth>(new AuthPayloadSessionAuth());
    }
  }
}
